<ion-content
  class="form-content"
  *ngIf="authServ.isLogged || menuItem.profile_is_not_required; else noLogged"
>
  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button
        (click)="close()"
        fill="clear"
        color="dark"
        class="ion-no-padding"
      >
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img
          [src]="dataServ.rData.dark_logo"
          *ngIf="dataServ.rData && dataServ.rData.dark_logo[0]"
        ></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">
    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1>
            <b>{{ menuItem.name | caption | translate }}</b>
          </h1>
        </ion-text>
      </ion-col>

      <ion-col size="12">
        <ion-item>
          <ion-label position="stacked">{{ "Time" | translate }}</ion-label>
          <ion-datetime
            display-format="HH:mm"
            [(ngModel)]="orderTime"
          ></ion-datetime>
        </ion-item>
      </ion-col>

      <ion-col size="12">
        <ion-list>
          <ng-container *ngFor="let item of cartServ.cart; let i = index">
            <ion-item [ngClass]="animateClasses[i]">
              <ion-label>
                <span class="Montserrat">{{ item.size.quantity }} x </span>
                <span
                  class="Montserrat"
                  [innerHTML]="
                    item.product.name | caption | translate | slice : 0 : 32
                  "
                ></span>
                <span
                  *ngIf="(item.product.name | caption | translate)?.length > 32"
                  >...</span
                >

                <ng-container *ngIf="item.size.size | caption | translate">
                  (<span
                    class="Montserrat"
                    [innerHTML]="item.size.size | caption | translate"
                  ></span
                  >)
                </ng-container>

                <ion-text color="primary" class="ion-float-right">
                  <ng-container
                    *ngIf="item.size.currency_code === 'TL'; else otherLang"
                  >
                    <b
                      >{{ item.amount | customCurrency }}
                      {{ item.size.currency_code }}</b
                    >
                  </ng-container>
                  <ng-template #otherLang>
                    <ion-text color="primary">
                      <b
                        >{{ item.size.currency_code
                        }}{{ item.amount | customCurrency }}</b
                      >
                    </ion-text>
                  </ng-template>
                </ion-text>
              </ion-label>

              <ion-icon
                (click)="writeNote(item)"
                color="primary"
                name="create-outline"
              ></ion-icon>
            </ion-item>
          </ng-container>

          <!-- Service Charge Alanı (BURAYA EKLEYİN) -->
          <ion-item
            *ngIf="
              cartServ.cart.length > 0 &&
              cartServ.totalAmount < menuItem.free_service_over_amount &&
              cartServ.totalAmount !== 0
            "
          >
            <ion-label class="Montserrat">
              {{ "Service Charge" | translate }}
              <ion-text color="primary" class="ion-float-right">
                <!-- Fixed (0) -->
                <ng-container
                  *ngIf="menuItem.service_charge_type === 0; else percentCharge"
                >
                  <ng-container
                    *ngIf="
                      menuItem.service_charge_currency_code === 'TL';
                      else currencyFirst
                    "
                  >
                    <b>
                      {{ menuItem.service_charge | customCurrency }}
                      {{ menuItem.service_charge_currency_code }}
                    </b>
                  </ng-container>
                  <ng-template #currencyFirst>
                    <ion-text color="primary">
                      <b>
                        {{ menuItem.service_charge_currency_code
                        }}{{ menuItem.service_charge | customCurrency }}
                      </b>
                    </ion-text>
                  </ng-template>
                </ng-container>
                <!-- Percentage (1) -->
                <ng-template #percentCharge>
                  <ng-container>
                    <b>
                      {{ menuItem.service_charge }}%
                      <!-- Hesaplanan tutarı göster -->
                      (
                      {{
                        cartServ.totalAmount * (menuItem.service_charge / 100)
                          | customCurrency
                      }}
                      {{ menuItem.service_charge_currency_code }}
                      )
                    </b>
                  </ng-container>
                </ng-template>
              </ion-text>
            </ion-label>
          </ion-item>

          <!-- Toplam Satırı -->
          <ion-item>
            <ion-label class="Montserrat">
              {{ "Total" | translate }}
              <ion-text color="primary" class="ion-float-right">
                <ng-container
                  *ngIf="cartServ.currencyCode === 'TL'; else otherLang"
                >
                  <b>
                    {{
                      cartServ.totalAmount +
                        (cartServ.totalAmount <
                          menuItem.free_service_over_amount &&
                        cartServ.totalAmount !== 0
                          ? menuItem.service_charge_type === 0
                            ? menuItem.service_charge
                            : (cartServ.totalAmount * menuItem.service_charge) /
                              100
                          : 0) | customCurrency
                    }}
                    {{ cartServ.currencyCode }}
                  </b>
                </ng-container>
                <ng-template #otherLang>
                  <ion-text color="primary">
                    <b>
                      {{ cartServ.currencyCode }}
                      {{
                        cartServ.totalAmount +
                          (cartServ.totalAmount <
                            menuItem.free_service_over_amount &&
                          cartServ.totalAmount !== 0
                            ? menuItem.service_charge_type === 0
                              ? menuItem.service_charge
                              : (cartServ.totalAmount *
                                  menuItem.service_charge) /
                                100
                            : 0) | customCurrency
                      }}
                    </b>
                  </ion-text>
                </ng-template>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>

    <app-extra-forms></app-extra-forms>

    <ion-row>
      <ion-col
        size="12"
        *ngIf="menuItem.profile_is_not_required && !authServ.isLogged"
      >
        <ion-item>
          <ion-label position="stacked"
            >{{ "Name" | translate }}
            <ion-text color="primary">*</ion-text>
          </ion-label>
          <ion-input type="text" [(ngModel)]="name"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked"
            >{{ "Phone Number" | translate }}
          </ion-label>
          <ion-input type="tel" [(ngModel)]="phoneNumber"></ion-input>
        </ion-item>
      </ion-col>

      <ion-col size="12" *ngIf="menuItem.profile_is_not_required">
        <ion-item>
          <ion-label position="stacked"
            >{{ menuItem.capacity_name | caption }}
            <ion-text color="primary">*</ion-text>
          </ion-label>
          <ion-input type="text" [(ngModel)]="capacityName"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-item>
          <ion-textarea
            #noteInput
            rows="2"
            placeholder="{{ 'Notes' | translate }}"
          ></ion-textarea>
        </ion-item>
      </ion-col>

      <ion-col size="12">
        <ion-button
          (click)="send(noteInput.value)"
          class="send-button"
          expand="block"
          color="primary"
          [disabled]="
            isSubmitting ||
            (menuItem.profile_is_not_required &&
              (!capacityName ||
                (menuItem.profile_is_not_required &&
                  !authServ.isLogged &&
                  !name)))
          "
        >
          <ion-spinner name="crescent" *ngIf="isSubmitting"></ion-spinner>
          <span *ngIf="!isSubmitting">{{ "Send" | translate }}</span>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ng-template #noLogged>
  <!-- <ion-button (click)="close()" fill="clear" color="light" class="ion-no-padding login-back">
    <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
  </ion-button> -->
  <app-profile [isModal]="true"></app-profile>
</ng-template>
